import { storeToRefs } from 'pinia'
import { useDataStore } from '@/stores/DataStore'
import { useDevStore } from '@/stores/DevStore'

const FullScreen = {
  enable,
  cancel,
  isEnabled,
  isSupported,
  toggleAll
}

// listen event on document instead of element to avoid firefox limitation
// see https://developer.mozilla.org/en-US/docs/Web/Guide/API/DOM/Using_full_screen_mode
// document.on('fullscreenchange webkitfullscreenchange mozfullscreenchange MSFullscreenChange', () => {});

function enable() {
  const dataStore = useDataStore()
  const { fullscreenElement } = storeToRefs(dataStore)

  const element = fullscreenElement.value
  if (!element) return

  if (element.requestFullScreen) {
    element.requestFullScreen()
  } else if (element.mozRequestFullScreen) {
    element.mozRequestFullScreen()
  } else if (element.webkitRequestFullscreen) {
    element.webkitRequestFullscreen()
  } else if (element.msRequestFullscreen) {
    element.msRequestFullscreen()
  }
}

function cancel() {
  if (document.cancelFullScreen) {
    return document.cancelFullScreen()
  } else if (document.mozCancelFullScreen) {
    return document.mozCancelFullScreen()
  } else if (document.webkitExitFullscreen) {
    return document.webkitExitFullscreen()
  } else if (document.webkitCancelFullScreen) {
    return document.webkitCancelFullScreen()
  } else if (document.msExitFullscreen) {
    return document.msExitFullscreen()
  }
}

function isEnabled() {
  let fullscreenElement =
    document.fullscreenElement ||
    document.mozFullScreenElement ||
    document.webkitFullscreenElement ||
    document.webkitIsFullScreen ||
    document.webkitCurrentFullscreenElement ||
    document.msFullscreenElement
  return fullscreenElement ? true : false
}

function toggleAll() {
  const DEV_STORE = useDevStore()
  if (!DEV_STORE.forceFullscreen) return
  FullScreen.isEnabled() ? FullScreen.cancel() : FullScreen.enable()
}

function isSupported() {
  let docElm = document.documentElement
  let requestFullscreen =
    docElm.requestFullScreen ||
    docElm.mozRequestFullScreen ||
    docElm.webkitRequestFullscreen ||
    docElm.msRequestFullscreen
  return requestFullscreen ? true : false
}

export default FullScreen
